import { render, staticRenderFns } from "./BasketTotals.vue?vue&type=template&id=7989d666"
import script from "./BasketTotals.vue?vue&type=script&lang=js"
export * from "./BasketTotals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports